import { WrappedFieldInputProps, WrappedFieldMetaProps } from 'redux-form';

export default function defaultShouldError(
  _input: WrappedFieldInputProps,
  meta: WrappedFieldMetaProps,
) {
  return meta.touched;
}
